/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { Component } from "react";

//import SliderItemNew from "./SliderItem_new";


//@ts-ignore
import Slider from "react-slick";

// @ts-ignore
export class SliderNew extends Component {
    
    
  render() {

    const sliders = [
        {
          image:
            "https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-Margaritaville-Parrothead-Hero-1-630x420.jpg",
          title: "Margaritaville",
          id: "margaritaville",
          page_link: "https://www.obrien.com/margaritaville"
        },
        {
            image:
                "https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Sombrero-5-Hero-1-630x420.jpg",
            title: "Tubes",
            id: "tubes",
            page_link: "htttps://www.obrien.com/obrien-watersports/obrien/tubes/5637187354.c"
        },
        {
            image:
                "https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Pontoon-1-630x420.jpg",
            title: "waterskis",
            page_link: "https://www.obrien.com/obrien-watersports/obrien/waterskis/5637187347.c"
        },
        {
            image:
                "https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-1-630x420.jpg",
            title: "wakesurf",
            page_link: "https://www.obrien.com/obrien-watersports/obrien/wakesurf/5637187331.c"
        },
        {
          image:
            "https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Shota-Valhalla-Hero-1-630x420.jpg",
          title: "wakeboards",
          page_link: "https://www.obrien.com/obrien-watersports/obrien/wakeboards/5637187336.c"
        }
        
      ];
      
      const settings = {
        className: "slide-center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        };

      return (
        <div className="App">
            <Slider {...settings}>
                {sliders.map((slider) => (
                    <div id={slider.id} className="sliiick" key={slider.id}>
                        <a href={slider.page_link}>
                            <img src={slider.image} alt={slider.title} />
                            <h3>{slider.title}</h3>
                        </a>
                    </div>
                ))}
            </Slider>
        </div>
      );
  }

}
export default SliderNew;
